import {
	TAGGED_DATE_EDIT_BUTTON_CLICKED,
	TAGGED_DATE_EDIT_BUTTON_CLICKED_RESET,
	UPDATE_TAGGED_DATE_REQUEST,
	UPDATE_TAGGED_DATE_REQUEST_FAILED,
	UPDATE_TAGGED_DATE_REQUEST_RESET,
	UPDATE_TAGGED_DATE_REQUEST_SUCCESS,
} from "../types"

const initialState = {
	tagggedDateButtonClicked: false,
	isTaggedDateUpdated: false,
	isTaggedDateUpdateInprogess: false,
	taggedDateData: {},
}

// eslint-disable-next-line
export default function (state = initialState, action) {
	switch (action.type) {
		case TAGGED_DATE_EDIT_BUTTON_CLICKED: {
			return {
				...state,
				tagggedDateButtonClicked: true,
			}
		}
		case TAGGED_DATE_EDIT_BUTTON_CLICKED_RESET: {
			return {
				...state,
				tagggedDateButtonClicked: false,
			}
		}
		case UPDATE_TAGGED_DATE_REQUEST: {
			return {
				...state,
				isTaggedDateUpdateInprogess: true,
			}
		}
		case UPDATE_TAGGED_DATE_REQUEST_SUCCESS: {
			return {
				...state,
				isTaggedDateUpdateInprogess: false,
				isTaggedDateUpdated: true,
				taggedDateData: action.payload,
			}
		}
		case UPDATE_TAGGED_DATE_REQUEST_FAILED: {
			return {
				...state,
				isTaggedDateUpdateInprogess: false,
				isTaggedDateUpdated: false,
			}
		}
		case UPDATE_TAGGED_DATE_REQUEST_RESET: {
			return {
				...state,
				...initialState,
			}
		}

		default:
			return state
	}
}
